import React from "react";
import { Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useRegistrationStyles } from "./registrationStyles";
import { DNA } from "@dna/react";
const useStyles = makeStyles({
  root: {
    width: "100%",
    height: "calc(100vh - 48px)",
    overflow:"hidden"
  },
  items: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rightSection: {
    background: "radial-gradient(50% 50% at 50% 50%, #2AA4A2 0%, #025450 100%)",
    "& label": {
      color: "#FFFFFF",
      "&.title": {
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: "28px",
      },
      "&.subTitle": {
        fontSize: "16px",
        lineHeight: "24px",
        marginTop: "20px",
        marginBottom: "20px",
      },
    },
  },

  anchorStyle:{
    fontSize:"16px"
  }
});
export const Logout = () => {
  let classes = useStyles();
  let classes2 = useRegistrationStyles();
  return (
    
    <Grid
      container
      spacing={0}
      className={classes.root}
    >
      <Grid
        item
        xs={6}
        className={classes.items}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Box style={{ minHeight: "550px" }}>
          <Box className={classes2.titleBig}>You are now signed out</Box>
          <Box className={classes2.sectionTitle}>
            You have been successfully signed out of MedPoint.
          </Box>
          <Grid container direction={"column"} spacing={2}>
            <Grid item>
              <a href="/residents" className={classes.anchorStyle}>Return to sign-in screen</a>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid
        item
        xs={6}
        className={`${classes.items} ${classes.rightSection}`}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <img height="360px" width="480px" src="https://customb2ccontentstorage.blob.core.windows.net/signin-ui-content/images/medpoint-placeholder-image.png" />

        <label className="title">
          Simplify medication management in residential aged care.
        </label>
      </Grid>
    </Grid>
  );
};
